/** Focus and event helpers for the overlays and the table (internal: not re-exported from the kit's index). */

const FOCUSABLE = "a[href], button, input, select, textarea, [tabindex]";
const CONTROL = "a[href], button, input, select, textarea, label, summary, [role=button], [role=link], [role=checkbox], [role=switch], [role=menuitem], [contenteditable=true]";

/** Open Modal / Drawer panels, the top-most last: only that one answers Escape, its backdrop and Tab. */
const openOverlays: object[] = [];
export const overlayStack = {
  push: (o: object) => { openOverlays.push(o); },
  remove: (o: object) => { const i = openOverlays.indexOf(o); if (i >= 0) openOverlays.splice(i, 1); },
  isTop: (o: object) => openOverlays[openOverlays.length - 1] === o,
};

/** Elements inside the panel that Tab can reach, in document order. */
export function focusables(panel: HTMLElement): HTMLElement[] {
  return [...panel.querySelectorAll<HTMLElement>(FOCUSABLE)]
    .filter((el) => el.tabIndex >= 0 && !el.matches(":disabled, input[type=hidden]") && el.getClientRects().length > 0);
}

/** Where Tab (or Shift+Tab when `back`) must send focus to stay inside the panel; null lets the browser move it. */
export function wrapTab<T>(items: readonly T[], active: T | null, back: boolean): T | null {
  if (!items.length) return null;
  const i = active === null ? -1 : items.indexOf(active);
  if (back) return i <= 0 ? items[items.length - 1]! : null;
  return i === -1 || i === items.length - 1 ? items[0]! : null;
}

/** Horizontal tabs use arrows/Home/End; other keys keep their native behaviour. */
export function tabKeyIndex(key: string, index: number, count: number): number | null {
  if (!count) return null;
  if (key === "ArrowRight") return (index + 1) % count;
  if (key === "ArrowLeft") return (index + count - 1) % count;
  if (key === "Home") return 0;
  if (key === "End") return count - 1;
  return null;
}

/** True when the event started on a control inside the row (button, link, field), which handles it itself. */
export function fromControl(target: EventTarget | null, row: Element): boolean {
  const el = target instanceof Element ? target.closest(CONTROL) : null;
  return el !== null && el !== row && row.contains(el);
}
